import * as server from "@/utils/http"

export const _page = params => server.get("/batch-output-log/page", params);

export const _download = (params,headerconfig,downloadProgress,downloadAfterHandle)=>server.download("/batch-output-log/download",params,headerconfig,downloadProgress,downloadAfterHandle)
